import React from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';

import Specializations from '../../../list/doctorsPageList/common/Doctor/specializations';
import defaultMedicSvg from '../../../../assets/img/next/svg/medic.svg';
import cabinetSvg from '../../../../assets/img/next/svg/cabinet.svg';
import screeningLogoSmall from '../../../../assets/img/skrinig40_52x48.svg';

export default function VisitInfo({ user, date, division, doctor, diagnoses, job, slot_type }) {
  const [primary, ...secondary] = diagnoses;

  return (
    <div className="personal-visits-list__item-about">
      <div className="visit-card">

        {/* Col left: Date + Hospital */}
        <div className="visit-card__col-left">
          <div className="visit-card__date">
            <span className="visit-card__label">Дата візиту</span>
            <div className="visit-card__date-value">{moment(date).format('DD.MM.YYYY')}</div>
          </div>
          {division ? (
            <NavLink
              to={`/city/${division.city_id}/hospitals/${division.institution_id}?division_id=${division.id}`}
              className="visit-card__hospital"
            >
              <span className="visit-card__label">Заклад охорони здоров'я</span>
              {division.full_name}
            </NavLink>
          ) : (
            <div className="visit-card__hospital">
              <span className="visit-card__label">Заклад охорони здоров'я</span>
              <span>Немає даних</span>
            </div>
          )}
        </div>

        <div className="visit-card__divider" />

        {/* Col right: Doctor + Diagnosis */}
        <div className="visit-card__col-right">
          <div className="visit-card__doctor">
            <div
              className="visit-card__doctor-icon"
              style={{
                backgroundImage: `url(${
                  doctor.is_virtual
                    ? cabinetSvg
                    : slot_type === 'screening_40_plus'
                      ? screeningLogoSmall
                      : doctor.photo || defaultMedicSvg
                })`,
                backgroundSize: doctor.is_virtual || slot_type === 'screening_40_plus' ? 'contain' : 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <div className="visit-card__doctor-body">
              <span className="visit-card__label">{doctor.is_virtual ? 'Кабінет' : 'Лікуючий лікар'}</span>
              <div className="visit-card__doctor-name">
                {doctor.is_virtual
                  ? job?.cabinet_name
                    ? job.cabinet_name
                    : job?.cabinet_num
                      ? `Кабінет №${job.cabinet_num}`
                      : 'Кабінет'
                  : slot_type === 'screening_40_plus'
                    ? `Кабінет скринінгу${job?.cabinet_num ? ' №' + job.cabinet_num : ''}`
                    : doctor.full_name}
              </div>
              {!doctor.is_virtual && (
                <Specializations
                  specializations={doctor.specializations}
                  className="visit-card__doctor-spec"
                />
              )}
            </div>
          </div>

          <div className="visit-card__diagnoses">
            <span className="visit-card__label">Діагноз</span>
            {diagnoses.length ? (
              <>
                {primary && (
                  <div className="visit-card__diagnosis-primary">
                    <i className="fas fa-file-medical visit-card__diagnosis-icon" />
                    <div>
                      <span className="visit-card__diagnosis-code">{primary.code}</span>
                      {' — '}
                      <span className="visit-card__diagnosis-name">{primary.name}</span>
                    </div>
                  </div>
                )}
                {secondary.map(({ code, name }) => (
                  <div className="visit-card__diagnosis-secondary" key={code}>
                    <span className="visit-card__diagnosis-code">{code}</span>
                    {' — '}
                    <span>{name}</span>
                  </div>
                ))}
              </>
            ) : (
              <div className="visit-card__diagnosis-empty">Немає даних</div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

